import { MaxUint256 } from '@ethersproject/constants/lib/bignumbers'
import { BigNumber } from 'ethers'
import { useMutation, useQuery, useQueryClient } from 'react-query'
import { getSISContract } from '~/contracts/getSISContract'
import { useVESISParams } from '~/hooks/useVESISParams'
import { sisTokenKeys } from '~/lib/queryKeys'
import { useWallet } from '~/lib/useWallet'

export function useApproveSISToken(amount?: BigNumber) {
	const { config, provider } = useVESISParams()

	const { web3, account } = useWallet()

	const queryClient = useQueryClient()

	const { data } = useQuery(
		sisTokenKeys.allowance(config.chain.id, account),
		() => {
			const contract = getSISContract(config, provider)

			return contract.allowance(account, config.votingEscrowAddress)
		},
		{
			enabled: !!account,
		}
	)

	const { isLoading, mutate } = useMutation(
		async () => {
			const contract = getSISContract(config, web3).connect(
				web3.getSigner(account)
			)

			const tx = await contract.approve(
				config.votingEscrowAddress,
				MaxUint256
			)

			await tx.wait()
		},
		{
			onSuccess() {
				queryClient.setQueryData(
					sisTokenKeys.allowance(config.chain.id, account),
					MaxUint256
				)
			},
		}
	)

	const needApprove = !!data && !!amount && (data.eq(0) || data.lt(amount))

	return {
		approve: mutate,
		isApproving: isLoading,
		needApprove,
	}
}
